function activateOnView() {
  // const animatedTexts = document.querySelectorAll('.c-animated-text');
  // const observerOptions = {
  //   root: null, // Отслеживание относительно viewport
  //   rootMargin: '0px',
  //   threshold: 1 // Процент видимости элемента для срабатывания
  // };
  // const observerCallback = (entries) => {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       entry.target.classList.add('is-active');
  //     } else {
  //       entry.target.classList.remove('is-active');
  //     }
  //   });
  // };
  // const observer = new IntersectionObserver(observerCallback, observerOptions);
  // animatedTexts.forEach(animatedText => {
  //   observer.observe(animatedText);
  // });
}

export default activateOnView;
